import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { getEvent, postEvent } from "../api/crud";
import _ from "lodash";
import ModalView from "../Components/ModalView";
import { useForm, Controller } from "react-hook-form";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { updateSnackbar } from "../redux/action/dataAction";
import { convertDateToString, timeSince } from "../utils/function";
import { Link, useNavigate } from "react-router-dom";

const Event = () => {
  const dispatch = useDispatch();
  const { register, control, handleSubmit, reset } = useForm();
  const [eventList, setEventList] = useState([]);
  const [eventListFilter, setEventListFilter] = useState([]);
  const [yearSelected, setYearSelected] = useState("");
  const [optionYear, setOptionYear] = useState([]);
  const [modalAddOpen, setModalAddOpen] = useState(false);

  const onHandleChangeYear = (ev) => {
    setYearSelected(ev.target.value);

    const filterList = eventList.filter(
      (item) => item.year === ev.target.value
    );

    setEventListFilter(filterList);
  };

  const onHandleAddEvent = async (event) => {
    const params = {
      event_id: event.event_id,
      event_title: event.event_title,
      event_date: format(event.event_date.toDate(), "yyyy-MM-dd"),
      event_time: `${format(event.event_time_start.toDate(), "HH.mm")}-${format(
        event.event_time_end.toDate(),
        "HH.mm"
      )}`,
      expert: event.expert,
      place: event.place,
      Year: event.Year,
    };
    await postEvent({ ...params });
    setModalAddOpen(false);
    getEventList();
    reset();

    dispatch(
      updateSnackbar({
        open: true,
        content: "Successfully added Event",
      })
    );
  };

  const getEventList = () => {
    getEvent()
      .then((res) => {
        setEventList(res);

        const option = res.map((el) => {
          return {
            label: el.year,
            value: el.year,
          };
        });

        const uniqueOption = _.uniqBy(option, "value");
        const sortOption = [...uniqueOption].sort((a, b) => b.value - a.value);
        const yearNow = sortOption[0].value;

        const filterList = res.filter((item) => item.year === yearNow);

        setOptionYear(sortOption);
        setYearSelected(yearNow);
        setEventListFilter(filterList);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getEventList();
  }, []);

  const displayModalAdd = (
    <ModalView
      isModaOpen={modalAddOpen}
      setIsModalOpen={setModalAddOpen}
      title={<h4>เพิ่ม Event</h4>}
    >
      <form>
        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Event ID"
              variant="outlined"
              {...register("event_id", {
                required: true,
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Title"
              variant="outlined"
              {...register("event_title", {
                required: true,
              })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              control={control}
              name="event_date"
              rules={{
                required: true,
              }}
              render={({ field }) => {
                return (
                  <DatePicker
                    {...field}
                    label="Date"
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                );
              }}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <Controller
              control={control}
              name="event_time_start"
              rules={{
                required: true,
              }}
              render={({ field }) => {
                return (
                  <TimePicker
                    label="เวลาเริ่ม"
                    {...field}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                );
              }}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              name="event_time_end"
              render={({ field }) => {
                return (
                  <TimePicker
                    label="เวลาเสร็จสิ้น"
                    {...field}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                );
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="ผู้บรรยาย"
              variant="outlined"
              {...register("expert", {
                required: true,
              })}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="สถานที่"
              variant="outlined"
              {...register("place", {
                required: true,
              })}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="ปี (พ.ศ.)"
              variant="outlined"
              {...register("Year", {
                required: true,
              })}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="contained"
              onClick={handleSubmit(onHandleAddEvent)}
            >
              บันทึก
            </Button>
          </Grid>
        </Grid>
      </form>
    </ModalView>
  );

  const displayHeader = (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Button
        variant="contained"
        startIcon={<ControlPointIcon />}
        onClick={() => setModalAddOpen(true)}
      >
        เพิ่ม
      </Button>

      <FormControl fullWidth sx={{ maxWidth: "200px" }}>
        <InputLabel id="year-select">ปี</InputLabel>
        <Select
          labelId="year-select"
          value={yearSelected}
          label="Age"
          onChange={onHandleChangeYear}
        >
          {optionYear?.map((item) => {
            return (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );

  const displayTable = (
    <table className="table">
      <thead>
        <tr>
          {/* <th scope="col">id</th> */}
          <th scope="col">การอบรมเตรียมความพร้อมก่อนฝึกงานและปฏิบัติงานสหกิจศึกษา</th>
          
          {/* <th scope="col">ปี</th> */}
        </tr>
      </thead>
      <tbody>
        {eventListFilter?.map((item) => {
          return (
            <tr key={item.id}>
              {/* <th></th> */}
              <td>
                <div><span class="badge badge-soft-dark">{item.id}</span>{" "}<Link to={`/event-detail?id=${item.id}`}>{item.title}</Link></div> 
                <div><span class="badge badge-soft-info">{"วันที่ "}{convertDateToString(item.date)} เวลา {item.time} {" น."}</span></div>
                <span class="badge badge-soft-success">{item.expert}</span>
                </td>
              
              
              
              {/* <td>{item.year}</td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <div>
      {displayModalAdd}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {displayHeader}
        </Grid>
        <Grid item xs={12}>
          {displayTable}
        </Grid>
      </Grid>
    </div>
  );
};

export default Event;
